import axios from "axios";
import * as localforage from "localforage";
import { successHandling } from "../helpers/successHandling";

export const createAlarmPolicyAPI = async (
  rule,
  note,
  emails,
  t,
  successfulText
) => {
  const companyId = await localforage.getItem("companyId");

  await axios({
    url: `/api/v2/alarm/policy/create`,
    method: "POST",
    data: {
      company_id: companyId,
      alarm_policy_option_id: rule.id,
      operator: rule.operator,
      value: rule.value,
      note: note,
      emails: emails
    }
  });
  successHandling(t, successfulText);
  return true;
};
